// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dMdb","left":"styles_left__2_i4h"};